module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"size":"Data available from {metricAssignmentsWithValueSize} out of {metricAssignmentsSize} ventures"},"de":{"size":"Daten verfügbar von {metricAssignmentsWithValueSize} von {metricAssignmentsSize} Ventures"}}')
  delete Component.options._Ctor
}
